import { render, staticRenderFns } from "./VsPopupHistory.vue?vue&type=template&id=17efc1ed&scoped=true"
import script from "./VsPopupHistory.vue?vue&type=script&lang=js"
export * from "./VsPopupHistory.vue?vue&type=script&lang=js"
import style0 from "./VsPopupHistory.vue?vue&type=style&index=0&id=17efc1ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17efc1ed",
  null
  
)

export default component.exports